/**
 * A standard set of Easing functions
 * @param flFrac a variable from 0 to 1 which specifies the fractional progress of the animation.
 */
export function Linear(flFrac: number): number {
    return flFrac
}
export function EaseInQuad(flFrac: number): number {
    return flFrac * flFrac
}
export function EaseOutQuad(flFrac: number): number {
    return flFrac * (2 - flFrac)
}
export function EaseInOutQuad(flFrac: number): number {
    return flFrac < 0.5 ? 2 * flFrac * flFrac : -1 + (4 - 2 * flFrac) * flFrac
}
export function EaseInCubic(flFrac: number): number {
    return flFrac * flFrac * flFrac
}
export function EaseOutCubic(flFrac: number): number {
    const flFracM = flFrac - 1
    return flFracM * flFracM * flFracM + 1
}
export function EaseInOutCubic(flFrac: number): number {
    return flFrac < 0.5 ? 4 * flFrac * flFrac * flFrac : (flFrac - 1) * (2 * flFrac - 2) * (2 * flFrac - 2) + 1
}
export function EaseInQuart(flFrac: number): number {
    return flFrac * flFrac * flFrac * flFrac
}
export function EaseOutQuart(flFrac: number): number {
    const flFracM = flFrac - 1
    return 1 - flFracM * flFracM * flFracM * flFracM
}
export function EaseInOutQuart(flFrac: number): number {
    const flFracM = flFrac - 1
    return flFrac < 0.5 ? 8 * flFrac * flFrac * flFrac * flFrac : 1 - 8 * flFracM * flFracM * flFracM * flFracM
}
export function EaseInQuint(flFrac: number): number {
    return flFrac * flFrac * flFrac * flFrac * flFrac
}
export function EaseOutQuint(flFrac: number): number {
    const flFracM = flFrac - 1
    return 1 + flFracM * flFracM * flFracM * flFracM * flFracM
}
export function EaseInOutQuint(flFrac: number): number {
    const flFracM = flFrac - 1
    return flFrac < 0.5
        ? 16 * flFrac * flFrac * flFrac * flFrac * flFrac
        : 1 + 16 * flFracM * flFracM * flFracM * flFracM * flFracM
}
